import { Box } from "@mui/system";

function FormLayout({ children }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "25px",
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default FormLayout;
